export const APP_NAME = 'Inovio Hub'

export const LANGUAGES = {
  English: 'en',
  Serbian: 'sr',
}

export const DEFAULT_LANGUAGE = LANGUAGES.English
export const DEFAULT_TIMEZONE = 'Europe/Belgrade'
export const DEFAULT_CURRENCY = 'RSD'

export const TIMEZONE_OPTIONS = [
  'UTC',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Belgrade',
  'Europe/Moscow',
  'America/New_York',
  'America/Chicago',
  'America/Los_Angeles',
  'Asia/Tokyo',
  'Asia/Dubai',
  'Australia/Sydney',
].map((tz) => ({ value: tz, label: tz }))

// Flags render through LanguageFlag (inline SVG) - emoji flags are unreliable
// cross-platform, so no flag field lives here.
export const LANGUAGE_OPTIONS = [
  { value: LANGUAGES.English, label: 'English' },
  { value: LANGUAGES.Serbian, label: 'Srpski' },
]
